import { useEffect, useState } from 'react';
import { aboutService } from '../Model/Services/aboutService.js';

// Empty shape so the UI has structure but no mocktext
export const EMPTY_ABOUT_CONTENT = {
  hero: { eyebrow: '', title: '', lead: '', meta: [] },
  portrait: { chip: '', quote: '', src: '' },
  stats: [],
  timeline: [],
  posts: [],
  postsButton: '',
  cta: { eyebrow: '', heading: '', button: '' },
};

export const useAboutContent = () => {
  const [content, setContent] = useState(() => aboutService.getCached());
  const [loading, setLoading] = useState(() => !aboutService.getCached());
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchContent = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await aboutService.get();
      setContent(data ?? EMPTY_ABOUT_CONTENT);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const saveContent = async (data) => {
    setSaving(true);
    setError(null);
    try {
      const saved = await aboutService.upsert(data);
      setContent(saved);
      return saved;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setSaving(false);
    }
  };

  const uploadPortraitImage = async (file) => {
    setError(null);
    try {
      return await aboutService.uploadPortraitImage(file);
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const deletePortraitImageByUrl = async (imageUrl) => {
    setError(null);
    try {
      await aboutService.deletePortraitImageByUrl(imageUrl);
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  return {
    content,
    loading,
    error,
    saving,
    refresh: fetchContent,
    saveContent,
    uploadPortraitImage,
    deletePortraitImageByUrl,
  };
};
